import styled, { css } from 'styled-components';

// Shared base styles for all completed screens
const baseCompletedScreenStyles = css`
  .bg-secondary,
  .bg-primary {
    background-color: #00a651 !important;
  }

  .section-container {
    margin-bottom: 1.5rem;
  }

  .info-card {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border: none;
    overflow: hidden;
    height: 100%;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
    }
  }

  .card-header-custom {
    background: linear-gradient(135deg, #00a651 0%, #00873f 100%);
    padding: 1rem 1.25rem;
    border: none;
    display: flex;
    align-items: center;
    gap: 0.75rem;

    .header-icon {
      width: 36px;
      height: 36px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 1rem;
    }

    .header-title {
      color: #ffffff;
      font-size: 1.1rem;
      font-weight: 600;
      margin: 0;
    }
  }

  .info-list {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .info-item {
    display: flex;
    align-items: flex-start;
    padding: 0.875rem 1.25rem;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.15s ease;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: #fafafa;
    }

    .info-label {
      color: #6b7280;
      font-size: 0.875rem;
      font-weight: 500;
      min-width: 180px;
      flex-shrink: 0;
    }

    .info-value {
      color: #1f2937;
      font-size: 0.875rem;
      font-weight: 600;
      word-break: break-word;
    }
  }

  .section-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #00a651;
    
    h2 {
      font-size: 1.25rem;
      font-weight: 700;
      color: #1f2937;
      margin: 0;
    }

    .section-icon {
      color: #00a651;
      font-size: 1.25rem;
    }
  }

  .cards-row {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;

    > div {
      flex: 1;
      min-width: 300px;
    }
  }

  @media (max-width: 768px) {
    .info-item {
      flex-direction: column;
      gap: 0.25rem;

      .info-label {
        min-width: unset;
      }
    }

    .cards-row > div {
      min-width: 100%;
    }
  }

  /* Documents Section Styles */
  .documents-body {
    padding: 0;
  }

  .documents-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .document-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.15s ease;
    gap: 1rem;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: #fafafa;
    }
  }

  .document-content {
    flex: 1;
    min-width: 0;
    display: flex;
    gap: 1rem;
    align-items: flex-start;
  }

  .document-number {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #00a651 0%, #00873f 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.875rem;
    flex-shrink: 0;
  }

  .document-info {
    flex: 1;
    min-width: 0;
  }

  .document-type-name {
    font-weight: 600;
    color: #1f2937;
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }

  .document-details {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
  }

  .pdf-icon {
    flex-shrink: 0;
  }

  .document-filename {
    color: #6b7280;
    font-size: 0.85rem;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .doc-download-btn {
    padding: 0.25rem;
    border: none;
    background: transparent;
    border-radius: 6px;
    transition: background-color 0.15s ease;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
      background-color: #e5e7eb;
    }

    img {
      display: block;
    }
  }

  .document-name {
    font-weight: 600;
    color: #1f2937;
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }

  .document-actions {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 0.75rem;
    flex-wrap: wrap;

    .file-info {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      
      .file-name {
        color: #6b7280;
        font-size: 0.85rem;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .doc-btn {
      padding: 0.25rem;
      border-radius: 6px;
      transition: background-color 0.15s ease;
      cursor: pointer;

      &:hover {
        background-color: #e5e7eb;
      }
    }
  }

  .document-status {
    flex-shrink: 0;
    margin-left: 1rem;
  }

  .status-badge {
    padding: 0.35rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;

    &.status-warning {
      background-color: #fef3c7;
      color: #92400e;
    }

    &.status-danger {
      background-color: #fee2e2;
      color: #991b1b;
    }

    &.status-success {
      background-color: #d1fae5;
      color: #065f46;
    }

    &.status-info {
      background-color: #dbeafe;
      color: #1e40af;
    }
  }

  .document-motivation {
    color: #dc2626;
    font-size: 0.85rem;
    margin-top: 0.5rem;
  }

  .error-message {
    color: #dc2626;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    margin-bottom: 0;
  }

  @media (max-width: 576px) {
    .document-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.75rem;
    }

    .document-content {
      width: 100%;
    }

    .document-status {
      margin-left: 0;
    }

    .document-actions .file-info .file-name {
      max-width: 150px;
    }

    .document-filename {
      max-width: 150px;
    }
  }

  /* Modern Documents Grid Styles */
  .documents-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 1.25rem;
    padding: 1.25rem;
  }

  .document-card {
    width: 300px;
    background: #ffffff;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    transition: all 0.2s ease;
    position: relative;

    &:hover {
      border-color: #00a651;
      box-shadow: 0 4px 12px rgba(0, 166, 81, 0.15);
    }
  }

  .document-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .document-type-label {
    background: #f3f4f6;
    color: #374151;
    padding: 0.35rem 0.6rem;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .document-card-content {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-grow: 1;
    min-height: 80px;

    .pdf-icon-card {
      flex-shrink: 0;
      width: 48px;
      height: 48px;
      background: #fef2f2;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #dc2626;
      font-size: 1.25rem;
    }

    .document-card-name {
      font-size: 0.875rem;
      font-weight: 500;
      color: #1f2937;
      word-break: break-word;
      line-height: 1.4;
    }
  }

  .document-card-actions {
    display: flex;
    gap: 0.5rem;
    padding-top: 0.75rem;
    border-top: 1px solid #f0f0f0;

    .btn-download-card {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.4rem;
      padding: 0.6rem 1rem;
      background: linear-gradient(135deg, #00a651 0%, #00873f 100%);
      border: none;
      border-radius: 8px;
      color: #ffffff;
      font-size: 0.8rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 166, 81, 0.3);
      }

      img {
        filter: brightness(0) invert(1);
      }
    }

    .btn-upload-card {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.4rem;
      padding: 0.6rem 1rem;
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
      border: none;
      border-radius: 8px;
      color: #ffffff;
      font-size: 0.8rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
      }

      img {
        filter: brightness(0) invert(1);
      }
    }
  }

  .status-badge-card {
    padding: 0.35rem 0.6rem;
    border-radius: 6px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;

    &.status-valid {
      background: #dcfce7;
      color: #166534;
    }

    &.status-invalid {
      background: #fee2e2;
      color: #991b1b;
    }

    &.status-pending {
      background: #fef3c7;
      color: #92400e;
    }

    &.status-not-required {
      background: #e5e7eb;
      color: #4b5563;
    }
  }

  @media (max-width: 768px) {
    .documents-grid {
      justify-content: center;
    }

    .document-card {
      width: 100%;
      max-width: 340px;
    }
  }
`;

export const AutoCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const ProfessionCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const TravelCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const TutelaLegaleCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const TutelaCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const MotoCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const CommercialCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const HomeCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const SaluteCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const PublicEmploymentCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const MalattiaCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const InfortunioCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const CondominioCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const RcFamigliaCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const AncillariAutoCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const SanitariaStranieriCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const ProfessioniSanitaCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const OfflineCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;

export const MonopattiniCompletedScreenStyles = styled.div`
  ${baseCompletedScreenStyles}
`;
